<div *ngIf="training" id="training-detail-container" class="container">
    <h1>
        <i
            *ngIf="!trainingPicturePath"
            class="fa fa-code fa-pre"
            aria-hidden="true"
        ></i>

        <img
            *ngIf="trainingPicturePath"
            class="logo"
            src="{{ trainingPicturePath + '?timeupdate=' + time }}"
        />

        {{ training.title }}

        <div class="reference">{{ training.reference }}</div>
    </h1>

    <ul class="nav nav-tabs nav-justified" role="tablist">
        <li
            role="presentation"
            class="sessions-calendar"
            [ngClass]="{ active: active === 'details' }"
        >
            <a
                aria-controls="details"
                role="tab"
                data-toggle="tab"
                (click)="toggleTab('details')"
            >
                <h3>
                    {{
                        'training-detail.training.details.tabTitle' | translate
                    }}
                </h3>
            </a>
        </li>
        <li
            role="presentation"
            class="session-calendar"
            [ngClass]="{ active: active === 'planned-sessions' }"
        >
            <a
                aria-controls="planned-sessions"
                role="tab"
                data-toggle="tab"
                (click)="toggleTab('planned-sessions')"
            >
                <h3>
                    {{
                        'training-detail.planned-session-list.tabTitle'
                            | translate
                    }}
                </h3>
            </a>
        </li>

        <li
            role="presentation"
            class="session-calendar"
            [ngClass]="{ active: active === 'evaluations-sessions' }"
        >
            <a
                aria-controls="evaluations-sessions"
                role="tab"
                data-toggle="tab"
                (click)="toggleTab('evaluations-sessions')"
            >
                <h3>
                    {{ 'training-detail.evaluations.tabTitle' | translate }}
                </h3>
            </a>
        </li>
    </ul>

    <br />
    <div class="tab-content">
        <div
            role="tabpanel"
            class="tab-pane"
            id="details"
            [ngClass]="{ active: active === 'details' }"
        >
            <training-detail-description
                (getTraining)="trainingPictureFromChild($event)"
                (trainingSaved)="onTrainingSaved($event)"
                [trainingId]="training"
            ></training-detail-description>
        </div>

        <div
            role="tabpanel"
            class="tab-pane"
            id="planned-sessions"
            [ngClass]="{ active: active === 'planned-sessions' }"
        >
            <training-detail-planning
                [training]="training"
            ></training-detail-planning>
        </div>

        <div
            role="tabpanel"
            class="tab-pane"
            id="evaluations-sessions"
            [ngClass]="{ active: active === 'evaluations-sessions' }"
        >
            <training-detail-evaluation
                [training]="training"
            ></training-detail-evaluation>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/training/detail/detail.component.html